//This is sample of line items
export let sample_lineItems=      {
    "line_item_id": 114758,
    "default": 0,
    "hide_unit_price_column": 0,
    "name": "Tear-Off Existing Roof System",
    "description": "",
    "cost": 0,
    "quantity": 0,
    "adjusted_quantity": 0,
    "unit": "SQ",
    "net_cost": 0,
    "sort_order": 0,
    "manufacturer_id": 22,
    "sku": "",
    "scope_type_id": 1,
    "line_item_code": "tear-off-existing-roof-system",
    "convert_to": "",
    "ratio_from": 1,
    "ratio_to": 1,
    "convert_round": 0,
    "algorithm": "total_squares",
    "labor_cost": 0,
    "material_cost": 0,
    "profit": 65,
    "overhead": 15,
    "waste": 0,
    "notes": "",
    "sub_line_item": [
      "Dispose of All Roofing Material"
    ],
    "manufacturer": "",
    "apply_op": "",
    "product": "",
    "color": "",
    "remove_prices": 1,
    "doc_line_item_id": 4641548,
    "doc_id": 78973,
    "doc_structure_id": 341746,
    "doc_category_id": 430861,
    "adjusted_cost": 0,
    "selected_structure": ""
  }